// extracted by mini-css-extract-plugin
export default {"notify":"n5g54To2"};